<template>
  <f7-popup :id="nameId" :opened="popupOpened" @popup:opened="popupOpened = true" @popup:closed="popupOpened = false" style="overflow: hidden;">
    <page-nav-bar
      :subNavTitle="switchProfile_SwitchProfile"
      :closePopup="closeButton"
      :notLeftPanel="true"
      :notReturnButton="true"
      :picker="false">
    </page-nav-bar>
      <f7-list media-list class="switchProfileList"> <!--  style="" -->
          <f7-list-item
            v-for="accountItem in accounts"
            :key="accountItem.id"
            class="boxRequest"
            v-bind:media="'<div class=\'manualChip\'>'+accountItem.name[0].toUpperCase()+'</div>'"
            v-bind:title="accountItem.name"
            :subtitle="accountItem.identifier"
            :badge="selected(accountItem.id)"
            @click="switchAccount(accountItem.id)"
            v-bind:class="{'disabled' : notActive(accountItem.clearance)}"
            v-bind:text="noAccess(accountItem.clearance)">
          </f7-list-item>
      </f7-list>
  </f7-popup>
</template>

<script>

import pageNavBar from '@/components/common/pageNavBar.vue'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'switch-profile',
  components: {
    'page-nav-bar': pageNavBar
  },
  props: {
    closeButton: Boolean
  },
  data: () => {
    return {
      accounts: [],
      popupOpened: false,
      nameId: ''
    }
  },
  created () {
    this.switchProfile_SwitchProfile = this.$i18n.t('leftPanelTitle.swtch_prfl')
    let that = this
    this.nameId = 'switch-profile-' + this.closeButton
    this.$bus.$on('refresh-cache-menu', (val) => {
      that.accounts = this.$engine.accounts.get()
    })
  },
  methods: {
    switchAccount (id) {
      this.$engine.accounts.switchTo(id)
      this.popupOpened = false
      let link = ''
      switch (this.$engine.user.currentService.name) {
        case 'Direct Debit': link = (this.userIsGuest()) ? '/directDebit/inbox/' : '/directDebit/inbox/'; break
        // case 'Direct Payments': link = '/directPayments/inbox/'; break
        case 'Direct Payments': link = (this.userIsGuest()) ? '/directPayments/inbox/' : '/dashboard/'; break
        default: link = (this.userIsGuest()) ? '/payments/inbox/' : '/dashboard/'; break
      }
      loadPage(this, {url: link})
      this.$bus.emit('refresh-cache-menu')
    },
    selected: function (accountId) {
      if (accountId === this.$engine.user.get().id) { return this.$i18n.t('common.slctd') }
    },
    notActive: function (clearance) {
      let notActive = true
      for (var item in clearance) {
        if (clearance[item] !== '0') {
          notActive = false
        }
      }
      return notActive
    },
    noAccess: function (clearance) {
      if (this.notActive(clearance)) {
        return 'No access'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// switchProfile.vue?76be3afb